var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCognox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.74,
    y: 100.5,
    className: "st0",
    width: 153.66,
    height: 879
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.54,403.12v108.25c49.44-20.14,101.58-32.22,153.66-37.22v-81.1 C386.06,389.24,331.97,392.71,279.54,403.12 M410.08,979.5h252.32c257.81,0,395.85-143.24,395.85-438.83 c0-296.9-139.29-440.15-395.85-440.15H352.45c-49.44,0-72.91,23.4-72.91,71.59v186.92c51.73-4.31,104.57-0.69,153.66,14.93V269.81 c0-7.22,2.01-11.53,6.32-13.68c2.64-1.39,6.11-1.94,10.62-1.94h212.26c170.6,0,242.19,84.64,242.19,285.17 c0,201.85-71.59,286.49-242.19,286.49H412.15 M433.21,506.16c-55.41,19.65-108.18,49.3-153.66,84.29v317.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M859.11,634.2c-56.86-38.68-125.47-61.24-199.35-61.24c-196.01,0-354.95,158.94-354.95,354.95 c0,13.96,0.84,27.77,2.36,41.31c-18.68-11.11-27.64-31.52-27.64-61.38V590.45c45.48-34.99,98.25-64.64,153.66-84.29 c56.1-19.86,114.98-29.44,171.92-23.82c-54.44-10.76-113.11-14.02-171.92-8.19c-52.08,5-104.22,17.08-153.66,37.22V403.12 c52.42-10.42,106.51-13.89,153.66-10.07c25.76,2.15,49.37,6.53,69.64,13.12c-21.94-14.02-45.34-24.65-69.64-32.22 c-49.09-15.62-101.93-19.23-153.66-14.93v-97.14c55.2-7.64,109.57-9.72,159.98-5.76c146.64,11.39,259.4,73.32,259.4,196.64 C808.7,486.03,860.91,551.43,859.11,634.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.05,956.73c0,7.64,0.28,15.21,0.76,22.71h-71.72c-7.02-22.64-10.83-46.66-10.83-71.59 c0-132.55,107.49-240.04,240.04-240.04c8.12,0,16.11,0.42,24.02,1.18C555.55,719.95,481.05,829.59,481.05,956.73"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCognox);
export default __webpack_public_path__ + "static/media/logoCognox.2044db78f302069c45e9c6321c0f03ab.svg";
export { ForwardRef as ReactComponent };